import { action, thunk } from 'easy-peasy';
import { getPreviewCards, savePreviewCard, getPreviewCard, setAsDefault } from '../services/PreviewCards';

const PreviewCardsModel = {
  preview_cards: [],
  current_card: {},
  clearCurrentCard: action((state) => {
    state.current_card = {};
  }),
  showPreviewCard: action((state, new_current_card) => {
    state.current_card = new_current_card || {};
  }),
  showPreviewCards: action((state, new_preview_cards) => {
    state.preview_cards = new_preview_cards || [];
  }),
  savePreviewCard: thunk(async (actions, form) => {
    await savePreviewCard(form);
    await actions.showPreviewCards();
  }),
  getPreviewCards: thunk(async (actions, domain) => {
    let preview_cards = await getPreviewCards(domain);
    await actions.showPreviewCards(preview_cards);
  }),
  getPreviewCard: thunk(async (actions, {domain, card_id}) => {
    let preview_card = await getPreviewCard(domain, card_id);
    await actions.showPreviewCard(preview_card);
    return preview_card;
  }),
  setAsDefault: thunk(async (actions, {domain, card_id}) => {
      await setAsDefault(domain, card_id);
  })
};

export default PreviewCardsModel;
